var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecapCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.061,
    height: 31.116,
    viewBox: "0 0 33.061 31.116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_139",
    "data-name": "Raggruppa 139",
    transform: "translate(312 1012.091)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_136",
    "data-name": "Raggruppa 136",
    transform: "translate(-312 -1012.091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "calendar",
    d: "M27.227,2.945V1H21.393V2.945H11.669V1H5.834V2.945H0V32.116H33.061V2.945Zm-3.89,0h1.945v3.89H23.337Zm-15.558,0H9.724v3.89H7.779ZM31.116,30.172H1.945V12.822H31.116ZM1.945,10.878V4.89h3.89v3.89h5.834V4.89h9.724v3.89h5.834V4.89h3.89v5.988Z",
    transform: "translate(0 -1)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_137",
    "data-name": "Raggruppa 137",
    transform: "translate(6.985 14.224)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_202",
    "data-name": "Rettangolo 202",
    transform: "translate(0 6.985)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.975,
    height: 4.975,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 2.975,
    height: 2.975,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_198",
    "data-name": "Rettangolo 198",
    transform: "translate(6.993)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.975,
    height: 4.975,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 2.975,
    height: 2.975,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_203",
    "data-name": "Rettangolo 203",
    transform: "translate(0)",
    fill: "#e02027",
    stroke: "#ed1c24",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.975,
    height: 4.975,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 2.975,
    height: 2.975,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_201",
    "data-name": "Rettangolo 201",
    transform: "translate(6.993 6.985)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.975,
    height: 4.975,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 2.975,
    height: 2.975,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_199",
    "data-name": "Rettangolo 199",
    transform: "translate(13.985)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.975,
    height: 4.975,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 2.975,
    height: 2.975,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_200",
    "data-name": "Rettangolo 200",
    transform: "translate(13.985 6.985)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.975,
    height: 4.975,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 2.975,
    height: 2.975,
    fill: "none"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecapCalendarIcon);
export default __webpack_public_path__ + "static/media/recap-calendar-icon.8a5569ceb4f12c3d239e14be657d589f.svg";
export { ForwardRef as ReactComponent };